"use strict";

($dt => {

	const { on_nothing } = $dt.TopicGrid.Functions;

	/**
	 * Anonymous contact info select screen.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o1_i0 = (block, inner_screen, controller) => {
		// Anonymous contact info form if user is not logged in
		const { inner_elem } = inner_screen;
		const [ button_next_elem, button_prev_elem, form_elem ] = [
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('form')
		];

		button_prev_elem.addEventListener('click', () => {
			const { current_screen } = block;
			current_screen.outer = 0;
			current_screen.inner = 4;
			controller.SetScreenUI(block);
		});

		// Autocompleter
		const school_input_elem = form_elem.querySelector('input[name="school"]');
		let school_auto_complete = false;
		if (school_input_elem) {
			school_auto_complete = $dt.Schools.CreateNewSchoolAutoCompleter(school_input_elem);
		}

		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('eglxyorder', form => {
				const submit_form = () => {
					const { contact_info, current_screen, d3df_page_options } = block;

					controller.StartWaiting(block);

					// Form processing
					const data = $df.serialize(form_elem);
					if (school_auto_complete) {
						data.school = school_auto_complete.current_id;
					}

					// Known scheduling info for progressive form saving
					controller.SetSchedulingFormData(block, data);

					const on_success = resp => {
						// Save contact info
						const { entity } = resp;
						
						contact_info.firstname = entity.firstname.value;
						contact_info.lastname = entity.lastname.value;
						contact_info.school = parseInt(entity.school.value);
						if (resp.school_name) {
							contact_info.school_name = resp.school_name;
						}
						contact_info.email = entity.email.value;
						contact_info.phone = entity.phone.value;

						// New address info
						contact_info.street_address1 = entity.street_address1.value;
						contact_info.city = entity.city.value;
						contact_info.state = entity.state.value;
						contact_info.zip = entity.zip.value;

						// Transition Screen
						current_screen.outer = 0;
						current_screen.inner = 5;
						controller.SetScreenUI(block);
					};

					const on_validation_failed = errors => {
						controller.FormValidationFailed(form, errors);
					};

					const on_complete = () => {
						controller.EndWaiting(block);
					};

					d3df_page_options.onSuccess = on_success;
					d3df_page_options.pageIndex = 1;

					// Send to server for validation
					controller.ResetFormValidation(form);
					form.submitPage(data, d3df_page_options, on_validation_failed, on_nothing, on_complete);
				};

				const button_next_click = () => {
					form.currentContainer = form_elem;
					submit_form();
				};

				button_next_elem.addEventListener('click', $dt.Util.debounce(button_next_click, $df.debounceThreshold));

				/* This shouldn't be needed since we don't have an input type="submit"
				form_elem.addEventListener('submit', e => {
					e.preventDefault();
					form.currentContainer = form_elem;
					submit_form();
				}); */

				button_next_elem.removeAttribute('disabled');
			});
			
		});
		
		// Field prepopulators
		inner_screen.Show = () => {
			const { contact_info } = block;
			if (contact_info.anon) {
				[ 'firstname', 'lastname', 'email', 'phone', 'street_address1', 'city', 'state', 'zip' ].forEach(field_key => {
					//console.log(contact_info, contact_info[field_key]);
					if (contact_info[field_key]) {
						const field = form_elem.querySelector(`[name="${field_key}"]`);
						if (field) {
							field.value = contact_info[field_key];
						}
					}
				});

				if (contact_info.school && school_auto_complete) {
					school_auto_complete.current_id = contact_info.school;
					$dt.Schools.GetSchools(schools => {
						const found_school = schools.find(s => { return s.ID == school_auto_complete.current_id; });
						if (found_school) {
							school_input_elem.value = found_school.Name;
						}
					});
				}
			}
		};
	};

})(window.d3_wp_themejs);
